var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 24,
    viewBox: "0 0 6 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M2.99147 9.36585C4.42004 9.36585 5.5629 10.5366 5.5629 12C5.5629 13.4634 4.42004 14.6341 2.99147 14.6341C1.5629 14.6341 0.420044 13.4634 0.420044 12C0.420044 10.5366 1.5629 9.36585 2.99147 9.36585ZM0.420044 2.63415C0.420044 4.09756 1.5629 5.26829 2.99147 5.26829C4.42004 5.26829 5.5629 4.09756 5.5629 2.63415C5.5629 1.17073 4.42004 0 2.99147 0C1.5629 0 0.420044 1.17073 0.420044 2.63415ZM0.420044 21.3659C0.420044 22.8293 1.5629 24 2.99147 24C4.42004 24 5.5629 22.8293 5.5629 21.3659C5.5629 19.9024 4.42004 18.7317 2.99147 18.7317C1.5629 18.7317 0.420044 19.9024 0.420044 21.3659Z",
    fill: "#7B7484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/More.9244f7a5741487c1ab7ea965de097a9d.svg";
export { ForwardRef as ReactComponent };